// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3UjNa","info":"Note_info__2Dss2","note":"Note_note__1tkAJ","actions":"Note_actions__37rxP"};